import { Components } from '@mui/material/styles/components';
import { Theme } from '@mui/material/styles/createTheme';

export const ThemeMuiAutocomplete: Components<Omit<Theme, 'components'>>['MuiAutocomplete'] = {
  styleOverrides: {
    option: {
      '&:hover': {
        background: 'transparent',
      },
    },
  },
};
